import { render, staticRenderFns } from "./BasicInfoModal.vue?vue&type=template&id=68867592&scoped=true&"
import script from "./BasicInfoModal.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68867592",
  null
  
)

export default component.exports